import get from 'lodash.get';

export function flattenConnectionNodes(connection) {
    const edges = get(connection, 'edges') || [];
    return edges.map(({ node }) => node);
}
